<template>
  <div class="air-monitor-view" @dblclick="handleDblclick">
    <RightButton ref="rightButtonRef" />

    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import RightButton from './components/RightButton/index.vue';

export default {
  components: {
    RightButton
  },
  data() {
    return {
      isFullscreen: false
    };
  },
  mounted() {
    this.bindFullscreenChange();
  },
  beforeDestroy() {
    this.unbindFullscreenChange();
  },
  methods: {
    toPage({ name }) {
      this.$router.push({ name });
    },
    handleDblclick() {
      if (this.isFullscreen) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    enterFullscreen() {
      const el = this.$el;
      const method =
        el.requestFullscreen ||
        el.webkitRequestFullscreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (method) {
        method.call(el);
      }
    },
    exitFullscreen() {
      const doc = document;
      const method =
        doc.exitFullscreen ||
        doc.webkitExitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.msExitFullscreen;
      if (method) {
        method.call(doc);
      }
    },
    isFullscreenEnabled() {
      const doc = document;
      return !!(
        doc.fullscreenElement ||
        doc.webkitFullscreenElement ||
        doc.mozFullScreenElement ||
        doc.msFullscreenElement
      );
    },
    onFullscreenChange() {
      this.isFullscreen = this.isFullscreenEnabled();
    },
    bindFullscreenChange() {
      const doc = document;
      const events = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ];
      events.forEach(event => {
        doc.addEventListener(event, this.onFullscreenChange);
      });
    },
    unbindFullscreenChange() {
      const doc = document;
      const events = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
      ];
      events.forEach(event => {
        doc.removeEventListener(event, this.onFullscreenChange);
      });
    }
  }
};
</script>

<style lang="scss">
.air-monitor-view {
  height: 100%;
  position: relative;

  background-color: var(--air-monitor-bg);

  .content {
    width: calc(100% - 140px);
    height: 100%;

    box-sizing: border-box;

    padding: 20px 0 20px 20px;

    position: relative;
    z-index: 5;

    .custom-form-container {
      padding: 15px 15px 0 15px;
      box-sizing: border-box;
    }
  }

  .air-monitor-base-container {
    box-sizing: border-box;

    height: 100%;

    position: relative;

    .radio-group {
      position: absolute;
      left: 0;
      top: 0;

      .el-radio-button__inner {
        border-radius: 0 !important;
      }
    }

    .m-table {
      height: calc(100% - 80px);
    }
  }
}
</style>
